module.exports = __webpack_public_path__ + "img/9634e0c.png";